import { __ } from "@wordpress/i18n";
import { ReactComponent as YouTubelogo } from "../assets/youtube_logo.svg";
import { ReactComponent as Tag } from "../assets/tag.svg";
import { ReactComponent as Live } from "../assets/live.svg";
import { ReactComponent as Feeds } from "../assets/feeds.svg";
import { ReactComponent as CustomActions } from "../assets/custom_actions.svg";
import { ReactComponent as ConvertVideos } from "../assets/convert_videos.svg";
import { ReactComponent as AngleRight } from "../assets/angle_right.svg";

const SingleVideosSettings = () => {
  return (
    <>
      <div className="sbc-fs sbc-builder-footer-free-wrapper">
        <div className="sbc-settings-cta">
          <div className="sbc-cta-head-inner">
            <div className="sbc-cta-title">
              <div className="sbc-plugin-logo">
                <YouTubelogo />
              </div>
              <div className="sbc-plugin-title">
                <h3>
                  {__(
                    "Get more features with YouTube Feed Pro",
                    "feeds-for-youtube"
                  )}
                </h3>
                <div className="sbc-plugin-title-bt">
                  <span className="sbc-cta-discount-label">
                    <Tag />
                    {__("Lite Feed Users get a 50% OFF", "feeds-for-youtube")}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="sbc-cta-boxes">
            <div className="sbc-cta-box">
              <span className="sbc-cta-box-icon">
                <Live />
              </span>
              <span className="sbc-cta-box-title">
                {__("Show Live Streams", "feeds-for-youtube")}
              </span>
            </div>
            <div className="sbc-cta-box">
              <span className="sbc-cta-box-icon">
                <Feeds />
              </span>
              <span className="sbc-cta-box-title">
                {__(
                  "All Feed Types: Playlist, Favorites, Search",
                  "feeds-for-youtube"
                )}
              </span>
            </div>
            <div className="sbc-cta-box">
              <span className="sbc-cta-box-icon">
                <CustomActions />
              </span>
              <span className="sbc-cta-box-title">
                {__(
                  "Add custom actions to end of the video",
                  "feeds-for-youtube"
                )}
              </span>
            </div>
            <div className="sbc-cta-box">
              <span className="sbc-cta-box-icon">
                <ConvertVideos />
              </span>
              <span className="sbc-cta-box-title">
                {__("Convert videos to Wordpress posts", "feeds-for-youtube")}
              </span>
            </div>
          </div>
          <div className="sbc-cta-much-more">
            <div className="sbc-cta-mm-left">
              <h4>{__("And Much More!", "feeds-for-youtube")}</h4>
            </div>
            <div className="sbc-cta-mm-right">
              <ul>
                <li>{__("Add videos in a Carousel", "feeds-for-youtube")}</li>
                <li>{__("Show subscribers", "feeds-for-youtube")}</li>
                <li>{__("Show video details", "feeds-for-youtube")}</li>
                <li>{__("Fast and Effective Support", "feeds-for-youtube")}</li>
                <li>{__("Always up to date", "feeds-for-youtube")}</li>
                <li>
                  {__("30 day money back guarantee", "feeds-for-youtube")}
                </li>
              </ul>
            </div>
          </div>
          <div className="sbc-cta-bottom-trydemo">
            <a
              href="https://smashballoon.com/youtube-feed/demo?utm_campaign=youtube-free&utm_source=settings&utm_medium=footer-banner&utm_content=Try%20Demo"
              target="_blank"
            >
              {__("Try Demo", "feeds-for-youtube")}
              <AngleRight />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleVideosSettings;
